module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event_detail_couple_photo-2a3e4ea8b5b89c9fa6f0fa1585358708.jpg";